import { useState } from "react";
import { connect } from "react-redux";

import { FillEye, FillEyeSlash } from "../../../common/CustomIcons";

import { CheckPassword, ChangePassword, } from "../../../redux/v2/user/actions";

import { validations } from "../../../constants";


function ChagePasswordForm(props) {
    const [passwords, setPasswords] = useState({
        current: {
            value: "",
            visible: false,
            valid: true,
        },
        new: {
            value: "",
            visible: false,
            valid: true,
        },
        confirm: {
            value: "",
            visible: false,
            valid: true,
        },
    });

    if (((passwords.current.value != "" && passwords.current.valid) && passwords.new.valid && passwords.confirm.valid)) {
        props.toggleMainActionButton(true);
    } else {
        props.toggleMainActionButton(false);
    }

    return (
        <div id="change-pass-modal-form">
            <div className="row">
                <div className="inpt-label col-md-4" style={{
                    marginTop: passwords.current.value == ""
                        ? passwords.current.valid ? 0 : "-15px"
                        : "-15px"
                }}>
                    <label>CURRENT PASSWORD</label>
                </div>

                <div className="col-md-8">
                    <div className="input-with-end-icon-wrapper">
                        <input className="form-control" value={passwords.current.value} type={passwords.current.visible ? "text" : "password"}
                            onChange={async (e) => {
                                let value = e.target.value;

                                let newDetails = {
                                    ...passwords,
                                    current: {
                                        ...passwords.current,
                                        value: value,
                                        valid: false
                                    }
                                };
                                setPasswords(newDetails);

                                if (validations.passwordRegex.test(value)) {
                                    const res = await props.CheckPassword(value);
                                    setPasswords({
                                        ...passwords,
                                        current: {
                                            ...passwords.current,
                                            value: value,
                                            valid: res.match
                                        }
                                    });

                                }

                            }}
                        />

                        <div onClick={() => {
                            setPasswords({
                                ...passwords,
                                current: {
                                    ...passwords.current,
                                    visible: !passwords.current.visible
                                }
                            })
                        }}>
                            {
                                passwords.current.visible
                                    ? <FillEye />
                                    : <FillEyeSlash />
                            }

                        </div>


                    </div>
                    {
                        passwords.current.valid
                            ? passwords.current.value != "" ? <span className="input-success-label">Password match! </span> : ""
                            : <span className="input-error-label">Password didn't match!</span>
                    }

                </div>
            </div>
            <div className="row">
                <div className="inpt-label col-md-4">
                    <label>NEW PASSWORD</label>
                </div>

                <div className="col-md-8">

                    <div className="input-with-end-icon-wrapper">
                        <input className="form-control" value={passwords.new.value} type={passwords.new.visible ? "text" : "password"}
                            onChange={(e) => {
                                let value = e.target.value;
                                props.setNewPassword(value);
                                setPasswords({
                                    ...passwords,
                                    new: {
                                        ...passwords.new,
                                        value: value,
                                        valid: validations.passwordRegex.test(value)
                                    }
                                })
                            }}
                        />

                        <div onClick={() => {
                            setPasswords({
                                ...passwords,
                                new: {
                                    ...passwords.new,
                                    visible: !passwords.new.visible
                                }
                            })
                        }}>
                            {
                                passwords.new.visible
                                    ? <FillEye />
                                    : <FillEyeSlash />
                            }

                        </div>

                    </div>
                    {
                        passwords.new.valid
                            ? ""
                            : <span className="input-error-label">Invalid password format! (atleast 8 characters with numbers, lowercase alpha, and uppercase alpha)</span>

                    }

                </div>
            </div>

            <div className="row">
                <div className="inpt-label col-md-4">
                    <label>CONFIRM PASSWORD</label>
                </div>

                <div className="col-md-8">
                    <div className="input-with-end-icon-wrapper">
                        <input className="form-control" value={passwords.confirm.value} type={passwords.confirm.visible ? "text" : "password"}
                            onChange={(e) => {
                                let value = e.target.value;
                                setPasswords({
                                    ...passwords,
                                    confirm: {
                                        ...passwords.confirm,
                                        value: value,
                                        valid: value == passwords.new.value
                                    }
                                })
                            }}
                        />
                        <div onClick={() => {
                            setPasswords({
                                ...passwords,
                                confirm: {
                                    ...passwords.confirm,
                                    visible: !passwords.confirm.visible
                                }
                            })
                        }}>
                            {
                                passwords.confirm.visible
                                    ? <FillEye />
                                    : <FillEyeSlash />
                            }

                        </div>
                    </div>
                    {
                        passwords.confirm.valid
                            ? ""
                            : <span className="input-error-label">Password didn't match!</span>

                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User
});

export default connect(mapStateToProps, {
    CheckPassword,
    ChangePassword,
})(ChagePasswordForm);
